import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer,toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import SelectComponent from '../../components/SelectComponent';



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



const EditCentros = () => {
  const [formData, setFormData] = useState({
    cod:'',
    descripcion:'',
    cod:'',
    direccion:'',
    tlf:'',
    status:false,
    externo:false,
    red_egresados:false,
  });

  const { id } = useParams(); // Obtener el id del curso de la URL
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [Centro,setCentro]=useState('');
  const [codError, setCodError] = useState('');  // Estado para mensajes de error del cod
  const [isCodValid, setIsCodValid] = useState(true);  // Estado para indicar si el cod es válido
  const [originalCod, setOriginalCod] = useState('');  // Almacena el valor original del cod
  

  useEffect(() => {
    setLoading(true);
    Promise.all([getCentro()]).finally(() => {
        setLoading(false);
    });
}, []);



  const getCentro = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/centro/${id}`,{headers: {
        Authorization: `Bearer ${token}`,
    }});
          
      const Centro = response.data;
      setCentro(Centro);
      setFormData({
        cod: Centro.cod || '',
        descripcion: Centro.descripcion || '',
        direccion: Centro.direccion || '',
        tlf: Centro.tlf || '',
        status:  Centro.status || false,
        externo:  Centro.externo || false,
        red_egresados: Centro.red_egresados === true || Centro.red_egresados === 'true',
      });
      setOriginalCod(Centro.cod); // Guarda el valor original de cod

    } catch (error) {
      setError('Error fetching Centro');
      console.error('Error fetching Centro:', error);
    }
  };

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  

  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
  
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }
  
      // 1. Actualizar los datos del curso
      const formDataWithStatus = {
        ...formData,
      };
  
      const procResponse = await axios.put(`/centro/${id}`, formDataWithStatus, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
            // Si hay campos vacíos, solo actualizamos los datos del participante
            toast.success('Formulario actualizado con éxito.');
        
  
      // Redirigir después de la actualización
      navigate('/centros');
  
    } catch (error) {
      // Captura cualquier error que ocurra en la solicitud
      toast.error('Error al actualizar curso o petición');
      console.error('Error actualizando:', error);
    }
  };
  

  const handleCodBlur = async () => {
    if (formData.cod && formData.cod !== originalCod) {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`centro/validate-cod/${formData.cod}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCodError('El código ya está en uso.');
            setIsCodValid(false);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setCodError('');
                setIsCodValid(true);
            } else {
                console.error('Error al verificar el código:', error);
                setCodError('Error verificando el código.');
                setIsCodValid(false);
            }
        }
    } else {
        setCodError('');
        setIsCodValid(true);
    }
};




  return (
    <div className="row" style={{ marginTop: '50px' }}>
    <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
      <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
        <h2 className="mb-2">Actualizar Centro</h2>
        <Form onSubmit={handleSubmit} className="custom-gutter">

          <Form.Group controlId="externo">
                              <Form.Label>¿Externo?</Form.Label>
                              <Form.Select
                                value={formData.externo ? 'true' : 'false'}
                                onChange={(e) => {
                                  const value = e.target.value === 'true';
                                  setFormData(prev => ({
                                    ...prev,
                                    externo: value,
                                  
                                  }));
                                }}
                              >
                                <option value="true">Si</option>
                                <option value="false">No</option>
                                
                              </Form.Select>
                            </Form.Group>
                  {/* Punto 14 de José (24/09): los centros marcados cuentan para la
                      vista "Red de egresados". */}
                  <Form.Group controlId="red_egresados" className="mt-2">
                    <Form.Label>¿Pertenece a la Red de egresados?</Form.Label>
                    <Form.Select
                      value={formData.red_egresados ? 'true' : 'false'}
                      onChange={(e) => {
                        const value = e.target.value === 'true';
                        setFormData(prev => ({ ...prev, red_egresados: value }));
                      }}
                    >
                      <option value="false">No</option>
                      <option value="true">Si</option>
                    </Form.Select>
                  </Form.Group>
              <Row className="g-2"> 
                          <Col md={6}>
                                <Form.Group controlId="descripcion">
                                  <Form.Label>Nombre de Centro</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="descripcion"
                                    value={formData.descripcion}
                                    onChange={handleChange}
                                    maxLength={255}
                                    required
                                  />
                                </Form.Group>
                          </Col>
              
                           <Col md={6}>
                               <Form.Group controlId="cod">
                            <Form.Label>COD</Form.Label>
                            <Form.Control
                                type="text"
                                name="cod"
                                value={formData.cod || ''}
                                onChange={(e) => {
                                    const uppercaseValue = e.target.value.toUpperCase();
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        cod: uppercaseValue
                                    }));
                                }}
                                onBlur={handleCodBlur}
                                className={codError ? 'is-invalid' : isCodValid ? 'is-valid' : ''}
                            />
                            {codError && (
                                <Form.Control.Feedback type="invalid">
                                    {codError}
                                </Form.Control.Feedback>
                            )}
                            {!codError && isCodValid && (
                                <Form.Control.Feedback type="valid">
                                    Código disponible.
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                          </Col>
                          </Row>
              
                           <Form.Group controlId="direccion">
                                  <Form.Label>Dirección</Form.Label>
                                  <Form.Control
                                    type="textarea"
                                    name="direccion"
                                    value={formData.direccion}
                                    onChange={handleChange}
                                    maxLength={255}
                                  />
                                </Form.Group>
              
                                <Form.Group controlId="tlf">
                                  <Form.Label>Teléfono</Form.Label>
                                  <Form.Control
                                    type="textarea"
                                    name="tlf"
                                    value={formData.tlf}
                                    onChange={handleChange}
                                    maxLength={30}
                                  />
                                </Form.Group>
                                <Form.Group controlId="status">
                                  <Form.Label>Status</Form.Label>
                                  <Form.Select
                                    value={formData.status ? 'true' : 'false'}
                                    onChange={(e) => {
                                      const value = e.target.value === 'true';
                                      setFormData(prev => ({
                                        ...prev,
                                        status: value,
                                      
                                      }));
                                    }}
                                  >
                                    <option value="false">Inactivo</option>
                                    <option value="true">Activo</option>
                                  </Form.Select>
                                </Form.Group>
  
            
        <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={() => navigate(-1)} className="me-2">
                Volver
            </Button>
            <Button variant="success" type="submit">
                Guardar
            </Button>
        </div>
      </Form>
    </div>
    </div>
    </div>
  );
};

export default EditCentros;
